import { render, staticRenderFns } from "./mobPartner.vue?vue&type=template&id=3a880542&scoped=true&"
import script from "./mobPartner.vue?vue&type=script&lang=js&"
export * from "./mobPartner.vue?vue&type=script&lang=js&"
import style0 from "./mobPartner.vue?vue&type=style&index=0&id=3a880542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a880542",
  null
  
)

export default component.exports